import { Link } from "@tanstack/react-router";
import { Mail } from "lucide-react";
import logoAsset480 from "@/assets/pulso33-logo-480.webp.asset.json";
const logoMark = logoAsset480.url;
import { useT, useMedia } from "@/lib/i18n";
import siteConfig from "@/config/site.json";
import navigation from "@/config/navigation.json";

export function Footer() {
  const { tk } = useT();
  const logo = useMedia("brand.logo.mark", logoMark, siteConfig.brand.name);
  return (
    <footer className="border-t border-gold/20">
      <div className="max-w-7xl mx-auto px-6 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <Link to="/" aria-label={logo.alt} className="flex items-center">
            <img src={logo.url} alt={logo.alt} width={220} height={31} className="h-8 w-auto" loading="lazy" decoding="async" />
          </Link>
          <p className="mt-6 text-sm text-muted-foreground leading-relaxed">
            {tk(siteConfig.brand.tagline_key, siteConfig.brand.tagline_default)}
          </p>
        </div>

        {navigation.footer.columns.map((col) => (
          <div key={col.titleKey}>
            <h3 className="text-xs tracking-[0.3em] uppercase text-gold mb-5 font-display">
              {tk(col.titleKey, col.titleDefault)}
            </h3>
            <ul className="space-y-3 text-sm text-foreground/70">
              {col.items.map((item) => (
                <li key={`${col.titleKey}:${item.to}:${item.labelKey}`}>
                  <Link to={item.to as "/"} className="hover:text-gold">
                    {tk(item.labelKey, item.labelDefault)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div>
          <h3 className="text-xs tracking-[0.3em] uppercase text-gold mb-5 font-display">
            {tk("footer.contact.title", "Get in touch")}
          </h3>
          <ul className="space-y-3 text-sm text-foreground/70">
            {siteConfig.contact.emails.map((e) => (
              <li key={e.address}>
                <a
                  href={`mailto:${e.address}`}
                  className="flex items-center gap-2 hover:text-gold"
                >
                  <Mail size={14} className="text-gold" />
                  <span>{e.address}</span>
                </a>
              </li>
            ))}
            <li>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 mt-2 rounded-full bg-gold text-primary-foreground px-4 py-2 text-[10px] tracking-[0.3em] uppercase font-semibold hover:bg-gold-soft transition-colors"
              >
                {tk("footer.contact.cta", "Start a project")}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gold/15">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs tracking-[0.2em] uppercase text-muted-foreground">
          <span>
            © {new Date().getFullYear()} {siteConfig.brand.name} — {tk("footer.rights", "All rights reserved")}
          </span>
          <span className="flex gap-5 items-center flex-wrap">
            {navigation.footer.legal.map((l) => (
              <Link key={l.labelKey} to={l.to as "/"} className="hover:text-gold">
                {tk(l.labelKey, l.labelDefault)}
              </Link>
            ))}
          </span>
        </div>
      </div>
    </footer>
  );
}
